import { useState } from 'react';
// import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import { Link } from 'react-router-dom';

import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import XIcon from '@/shared-components/icons/components/public/XIcon';
/* import SwitchInput from '@/shared-components/inputs/components/SwitchInput';*/
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Utils from '@/utils';

import './styles/ArtworkContract.css';

export default function ArtworkContract({ artworkData, open, close, /* onContractRenewalChange, */ onWithdrawArtwork }) {
  // const [formState, setFormState] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [openWithdrawArtwork, setOpenWithdrawArtwork] = useState(false);

  /* function changeRenewal(isAutomatic) {
    onContractRenewalChange(artworkData._id, isAutomatic);
    GalleryService.changeRenewalOfContract(artworkData._id, isAutomatic);
  } */ 

  async function withdrawArtwork() {
    setFormLoading(true);

    const { response } = await GalleryService.withdrawArtwork(artworkData._id);

    if(response.ok) {
      onWithdrawArtwork(artworkData._id);
    }
  }

  return (
    <>
      <GenericPopup 
        open={open}
        className="artwork-contract-popup"
        opacity
      >
        <div className="artwork-contract-popup__header">
          <h3 className="artwork-contract-popup__header-text">
            Artwork Agreement
          </h3>

          <XIcon className="artwork-contract-popup__close" onClick={close}/>
        </div>

        <ArtworkImage
          image={artworkData.artwork_media.artwork_main_picture.image_id}
          imageClassName="artwork-contract-popup__image"
          imageTemplateClassName="artwork-contract-popup__image"
        />

        <p className="artwork-contract-popup__text --less-margin">
                    Upload date:{" "}

          <span>
            {Utils.getDateInStringFromTimestamp(artworkData.createdAt)}
          </span>
          <p></p><br></br>
        </p>
        <p className="artwork-contract-popup__text">
          To mark the artwork as sold (0% commission), open the artwork, click In-gallery purchase, and select a gallery contact to transfer ownership. Withdrawing permanently deletes all community interactions and removes the artwork from your gallery admin.
        </p>
        <br></br>
        <p className="artwork-contract-popup__text">
                    Please visit the{" "} 

          <Link to="/artwork-agreement" target="_blank" rel="noreferrer">
                        Artwork Agreement
          </Link>
                     
          {" "}for more information.
        </p>

        {/* <div className="artwork-contract-popup__renewal-container">
          <span className="artwork-contract-popup__renewal-text">
                        Automatic renewal
          </span>

          <SwitchInput
            value={artworkData.artwork_flags.automatic_renewal !== false}
            onChange={isAutomatic=>changeRenewal(isAutomatic)}
          />
  </div>*/}

        <span className="artwork-contract-popup__withdraw-button element-non-selectable" onClick={()=>setOpenWithdrawArtwork(true)}>
                    Withdraw artwork
        </span>
      </GenericPopup>

      <GenericPopup
        open={openWithdrawArtwork}
        className="artwork-contract-popup_confirmation"
        opacity
      >
        <div className="artwork-contract-popup__header">
          <h3 className="artwork-contract-popup__header-text">
            Withdraw artwork
          </h3>

          <XIcon className="artwork-contract-popup__close" onClick={()=>setOpenWithdrawArtwork(false)}/>
        </div>

        <p className="artwork-contract-popup__text">
        Are you sure you want to withdraw this artwork from Suarte? For any questions or concerns please refer to galleries@suarte.art, and we will be happy to assist you.
        </p>

        {/* <PublicFormInput 
                    element="withdraw-artwork-checkbox" 
                    type="checkbox"
                    readOnly={formLoading}
                    value={formState} 
                    onChange={(value)=>setFormState(value)}
                >
                    I understand and accept the fee to be included in my next invoice.   
                </PublicFormInput> */}
                
        <ContinueButton
          loading={formLoading}
          // turnOff={!Boolean(formState)}
          className="artwork-contract-popup__submit-withdraw-button"
          onClick={withdrawArtwork}
        >
                    Withdraw artwork
        </ContinueButton>
      </GenericPopup>
    </>
  );
}
